import React from 'react'
import InstructorDashBoardHome from '../Dashboard/Instructor DashBoard/InstructorDashBoardHome'

const InstructorDashBoard = () => {
  return (
    <InstructorDashBoardHome/>
  )
}

export default InstructorDashBoard
